module.exports = require('./helpers/bundle-url').getBundleURL('1woTm') + "logo-dark.eefe0b7f.svg";